//* Importando o React
import { Form, FormControl as Input, InputGroup } from "react-bootstrap";

//* Importando o componente de atenção
import { Attention } from "../../component/base/Attention";

//* Importando a imagem de fundo
import BgVestibular from "../../assets/images/bg_vestibular.jpeg";

//* Importando a logo
import Logo from "../../assets/images/logo-ontest.png";

//* Importando o componente de input de senha
import PasswordInput from "../../component/base/PasswordInput";

//* Importando o componente de botão padrão
import DefaultButton from "../../component/base/DefaultButton";

//* Importando o useState do react
import { useState } from "react";

//* Importando o useDispatch do react-redux
import { useDispatch } from "react-redux";

//* Importando o componente de data e hora
import moment from "moment";

//* Importando a action de setTokenAndMe
import { setTokenAndMe } from "../../services/stores/auth/actions";

//* Importando o serviço de autenticação
import { AuthAPI } from "../../services/apis/AuthAPI";

//* Importando o componente Link do react-router-dom
import { Link, useNavigate } from "react-router-dom";



export function LoginView() {
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const login = async () => {
    setLoading(true);
    setErrorMessage("");

    try {
      const response = await AuthAPI.authorize(username, password);

      if (response.result) {
        const { user, access } = response.data;

        // Salva o token e os dados do usuário no Redux
        dispatch(
          setTokenAndMe({
            me: user,
            token: access.token,
          })
        );

        // Verifica se a senha é provisória
        if (!user.isPasswordDefinitive) {
          navigate("/change-password"); // Redireciona para a tela de definição de senha
        } else {
          navigate("/"); // Redireciona para o dashboard ou página inicial
        }
      } else {
        setErrorMessage(response.message || "Erro ao fazer login");
      }
    } catch (error) {
      setErrorMessage("Erro inesperado ao fazer login");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ height: "100vh" }}>
      <div className="row" style={{ backgroundColor: "white", margin: 0 }}>
        <div
          className="col-md-6 col-12 col-sm-12 col-lg-4 col-xl-4"
          style={{ margin: 0, padding: 0 }}
        >
          <div className="card" style={{ height: "100vh", margin: 0 }}>
            <div
              className="card-body"
              style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
            >
              <br />
              <div className="text-center">
                <div className="logo">
                  <img
                    style={{ maxHeight: 70 }}
                    src={Logo}
                    height="60"
                    alt="logo"
                  />
                </div>
              </div>
              <br />

              <div style={{ padding: "1rem", paddingBottom: 0, marginTop: 10 }}>
                <h4
                  className="font-18 m-b-5 text-center header-title"
                  style={{ fontSize: 18 }}
                >
                  Bem vindo !
                </h4>
                <p className="text-muted text-center" style={{ fontSize: 14 }}>
                  Faça login para continuar.
                </p>

                <form
                  className="form-horizontal m-t-30"
                  onSubmit={(e) => {
                    e.preventDefault();
                    login();
                  }}
                >
                  <InputGroup>
                    <div className="flex fdcolumn flex1 margin-bottom">
                      <Form.Label>
                        E-mail <Attention />
                      </Form.Label>
                      <Input
                        type="email"
                        style={{ fontSize: 14 }}
                        placeholder="E-mail"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        autoComplete="new-password"
                      />
                    </div>
                  </InputGroup>

                  <InputGroup>
                    <PasswordInput
                      label="Senha"
                      placeholder="Digite sua senha"
                      className="flex1"
                      value={password}
                      OnChangeText={(e: any) => setPassword(e.target.value)}
                      required
                    />
                  </InputGroup>

                  {/* Esqueci minha senha estilizado */}
                  <div
                    style={{
                      marginTop: "5px",
                      marginBottom: "15px",
                      textAlign: "left",
                    }}
                  >
                    <Link
                      to="/forgot-password"
                      style={{
                        fontSize: "0.9rem",
                        color: "#007bff", // Cor azul padrão
                        fontWeight: "bold", // Negrito para destaque
                        textDecoration: "none", // Sem sublinhado
                        transition: "color 0.3s ease, transform 0.2s ease", // Suavidade no hover
                      }}
                      onMouseEnter={(e) => {
                        (e.target as HTMLAnchorElement).style.color = "#0056b3"; // Azul mais escuro no hover
                        (e.target as HTMLAnchorElement).style.transform = "scale(1.05)"; // Leve aumento no hover
                      }}
                      onMouseLeave={(e) => {
                        (e.target as HTMLAnchorElement).style.color = "#007bff"; // Cor original
                        (e.target as HTMLAnchorElement).style.transform = "scale(1)"; // Tamanho original
                      }}
                    >
                      Esqueci minha senha
                    </Link>
                  </div>

                  <div className="form-group row m-t-20 m-b-10">
                    <div className="col-sm-12">
                      {errorMessage && (
                        <span
                          className="invalid-feedback"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                          role="alert"
                        >
                          <strong
                            style={{
                              textAlign: "center",
                              fontSize: "0.8rem",
                            }}
                          >
                            {errorMessage}
                          </strong>
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 text-right">
                      <DefaultButton
                        type="submit"
                        bg="primary"
                        width="100%"
                        height="3rem"
                        style={{ marginTop: "15px" }}
                        text="Entrar"
                        loadingtext="Entrando..."
                        loading={loading}
                      />
                    </div>
                  </div>
                </form>
              </div>
              <div className="text-center" style={{ marginTop: 20 }}>
                <p style={{ fontSize: 14 }}>
                  © {moment().format("YYYY")} OnTest
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-6 col-sm-6 col-12 col-lg-8 col-xl-8 d-none d-md-block"
          style={{
            overflow: "hidden",
            backgroundImage: `url(${BgVestibular})`,
            backgroundSize: "cover",
            padding: 0,
            margin: 0,
            height: "100vh",
          }}
        ></div>
      </div>
    </div>
  );
}
